<template>
    <div class="page">
        <van-nav-bar
            title="项目列表"
            left-arrow
        />
        <!-- <div class="tit">项目列表</div> -->
        <div class="centents">
            <div class="item-box" v-if="!isEmpty(list)">
                <div class="list-box">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <div class="list" data-flex="cross:center" v-for="(item, i) in list" :key="i" @click="toDetail(item.id)">
                            <img class="icon" data-flex-box="0" :src="item.storeLogo | qiniuResource"
                                mode="aspectFill" />
                            <div data-flex="dir:top main:justify">
                                <div class="ec2 f-fs16 f-fwb">{{item.pro}}丨{{item.projectName}}</div>
                                <div class="f-fs16" data-flex="cross:center">
                                    <p class="f-fs14" data-flex-box="1">{{item.statusName}}</p>
                                    <p class="f-fs14" data-flex-box="0">{{item.ctime}}</p>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </div>
            </div>
            <van-empty v-if="isEmpty(list)" description="暂无相关数据" />
        </div>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import minList from '@/mixins/list'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Field, Popup, Button, NumberKeyboard, Swipe, SwipeItem, Lazyload, Card, Tabbar, TabbarItem, List, Toast, Uploader, NavBar, Empty } from 'vant'
import { localStorageGet, localStorageSet, localStorageRemove } from '@/utils/storage'
import { cacheKeys } from '../../config/CacheKeys'
import MgPopup from '@/components/common/mg-popup'
import TabsBox from '@/components/common/tabs'
import FootBox from '@/components/common/foot'
import { userInfo } from 'os'

import pako from 'pako'
import wxShare from '@/utils/wxShare'

export default {
    mixins: [mix1, minList],
    name: 'HomeIndex',
    components: {
        MgPopup,
        TabsBox,
        FootBox,
        [Empty.name]: Empty,
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Field.name]: Field,
        [Popup.name]: Popup,
        NumberKeyboard,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Lazyload.name]: Lazyload,
        [Card.name]: Card,
        [Tabbar.name]: Tabbar,
        [TabbarItem.name]: TabbarItem,
        [List.name]: List,
        [Uploader.name]: Uploader
    },
    data() {
        return {
            searchData: {
                proId: '',
                cityId: '',
                countyId: '',
            },
            list: [],
        }
    },
    computed: {

    },
    methods: {
        onLoad() {
            // 下拉
            // 加载状态开始
            this.loading = true;
            this.pagination.page += 1
            
            this.getList()
        },
		toDetail(id) {
            this.$router.push('/detail?id=' + id)
		},
        async getList(type) {
            if(type){
                this.loading = true;
                this.finished = false;
                this.pagination.page = 1
                this.list = []
            }
            uiShowLoading()
            await delayAsync(500)

            const promise = this.apiGet('bi.work.orders', {
                ...this.searchData,
                ...this.pagination
            })

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }
            this.isDataLoaded = true
            
            // 加载状态结束
            this.loading = false;

            this.list = [...this.list, ...apiResult.list]

            // 数据全部加载完成
            if (this.list.length >= apiResult.pagination.recordTotal) {
                this.finished = true;
            }
        },
    },
    mounted() {
    },
    created() {
        let query = this.$route.query
        console.log('query', query)
        this.searchData = {
            proId: query.proId || '',
            cityId: query.cityId || '',
            countyId: query.countyId || '',
        },
        this.getList(true)
    }
}
</script>
<style lang="less" scoped>
/deep/ .van-nav-bar{
    background: #06385E;
}
/deep/ .van-nav-bar__left{
    display: none;
}
/deep/ .van-nav-bar__title{
    color: #fff !important;
    font-weight: bold;
}
/deep/ .van-nav-bar__arrow{
    font-size: 26px;
}
.page {
    background: #06385E;
    position: relative;
    min-height: calc(100vh);
    box-sizing: border-box;
    .tit{
        width: 100%;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        line-height: 100px;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9999;
        border-bottom: solid 1px #658197;
    }
    .centents{
        padding: 10px 50px;
        box-sizing: border-box;
        .item-box {
            box-sizing: border-box;
            .list-box {
                .list {
                    padding: 20px 0;
                    box-sizing: border-box;
                    color: #fff;
                    border-bottom: solid 1px #658197;
                    cursor: pointer;

                    >img {
                        width: 100px;
                        height: 100px;
                        border-radius: 10px;
                        margin-right: 20px;
                    }

                    >div {
                        height: 90px;
                        width: 100%;
                        .add {
                            width: 48px;
                            height: 48px;
                        }
                    }
                }
            }
        }

    }
}
</style>